import { Injectable } from "@angular/core";
import { AttachmentsStore } from "./store/attachments";
import { DeclarationsStore } from "./store/declarations";
import { GeneralDetailsStore } from "./store/general-details";
import { ProductsStoreService } from "./store/products";
import { RequestDetailsStore } from "./store/request-details";
import { ApplicantDetailsStore } from "./store/applicant-details";
import { GeneralStore } from "./store/general";
import { RequestApprovalTypeDetailsStore } from "./store/approval-type-details-store";
import { FieldsFormStateService } from "./fields/form-state";
import { AttachmentUploadStoreService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root',
})
export class RequestService {


    constructor(
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore,
        private generalStore: GeneralStore,
        private applicantDetailsStore: ApplicantDetailsStore,
        private generalDetailsStore: GeneralDetailsStore,
        private productsStoreService: ProductsStoreService,
        private requestDetailsStore: RequestDetailsStore,
        private attachmentsStore: AttachmentsStore,
        private declarationsStore: DeclarationsStore,
        private fieldsFormStateService: FieldsFormStateService,
        private attachmentUploadStore: AttachmentUploadStoreService,

    ) {

    }

    initMyImportFormState() {
        this.fieldsFormStateService.setFormState('isMyImport', true);
    }

    clearRequestStore() {
        this.requestApprovalTypeDetailsStore.initStore();
        this.generalStore.initStore();
        this.applicantDetailsStore.initStore();
        this.generalDetailsStore.initStore();
        this.productsStoreService.initStore();
        this.requestDetailsStore.initStore();
        this.attachmentsStore.initStore();
        this.declarationsStore.initStore();
        this.attachmentUploadStore.initStore();
        this.initMyImportFormState();
    }
}